import { useQuery } from '@tanstack/react-query';
import type { IMetadata } from '~/models/Metadata';
import { getMetadata } from '../clients/GetMetadata';

export const metadataKeys = {
  // No office scope: the answer depends on the signed-in user's type, never on the selected office.
  all: ['metadata'] as const,
};

/**
 * The metadata lists, loaded once per sign-in (GOTU-19709, P1 (a)): they are server constants that
 * change only with a deploy, so a screen that opens later reuses the cached answer, however long
 * after the last one closed. Signing out (`reducers/index.js`) and switching office
 * (`sagas/officeSaga.js`) clear the query cache, so the next session loads them again.
 *
 * One request and no retry, as the saga it replaces sent: a failure leaves the pickers empty.
 */
export const useGetMetadata = () =>
  useQuery<IMetadata>({
    queryKey: metadataKeys.all,
    queryFn: getMetadata,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });
